import {
    StackerAPI,
    StackerActions,
    FETCH_STARTED,
    FETCH_COMPLETED,
    byID,
    without,
    fetchAndReturn,
    acceptHeaders,
} from "./utils/utils"
import { recordActions } from "./recordApi"
import { STACK_SELECTED } from "./stackApi"
import { unique } from "utils/utils"

// CONSTANTS
export const ACTIONS_FETCHED = "ACTIONS_FETCHED"
export const ACTION_CREATED = "ACTION_CREATED"
export const ACTION_UPDATED = "ACTION_UPDATED"
export const ACTION_REMOVED = "ACTION_REMOVED"

// API
class ActionApi extends StackerAPI {
    path = "actions/"
}
const actionApi = new ActionApi()

class ActionActions extends StackerActions {
    api = actionApi
    reducer = "actions"
    actionTypes = {
        fetched: ACTIONS_FETCHED,
        removed: ACTION_REMOVED,
        created: ACTION_CREATED,
        updated: ACTION_UPDATED,
    }
}

const exec = (action, payload) => {
    if (action.special === "RECORD_CREATE") {
        return recordActions.create({ ...payload, ...action.context })
    }
    if (action.special === "RECORD_UPDATE") {
        const id = payload.id
        payload.id = undefined
        return recordActions.update(id, { ...payload, ...action.context })
    }
}

let AA = new ActionActions()
AA.actions = { ...AA.actions, exec }
export const actionActions = AA.actions

// STATE
const initialState = {
    actions: [],
    entities: {},
    fetching: [],
}

// REDUCERS
export function actionReducer(state = initialState, reduxAction) {
    var actions, action, fetching
    switch (reduxAction.type) {
        case ACTIONS_FETCHED:
            return {
                ...state,
                actions: unique([
                    ...state.actions,
                    ...reduxAction.payload.map(action => action._sid),
                ]),
                entities: { ...state.entities, ...byID(reduxAction.payload) },
            }
        case ACTION_CREATED:
            actions = [...state.actions, [reduxAction.payload._sid]]
            return {
                ...state,
                actions,
                entities: { ...state.entities, [reduxAction.payload._sid]: reduxAction.payload },
            }
        case ACTION_UPDATED:
            action = { ...state.entities[reduxAction.id], ...reduxAction.payload }
            return {
                ...state,
                entities: { ...state.entities, [action._sid]: action },
            }
        case ACTION_REMOVED:
            actions = state.actions.map(actions => without(actions, reduxAction.id))
            return {
                ...state,
                actions,
            }

        case FETCH_STARTED:
            return { ...state, fetching: [...state.fetching, reduxAction.key] }
        case FETCH_COMPLETED:
            fetching = state.fetching.filter(item => item !== reduxAction.key)
            return { ...state, fetching: fetching }

        case STACK_SELECTED:
            return initialState
        default:
            return state
    }
}

// SELECTORS
export const getActionEntities = state => state.actions.entities
export const getActions = state => {
    if (typeof state.actions.actions.map !== "function") debugger
    return state.actions.actions.map(actionId => state.actions.entities[actionId])
}

// HELPERS



// WEBPACK FOOTER //
// ./src/data/actionApi.js